export const ACCESS_TOKEN = 'CheckingIn.token';
